// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Alert2: React.FC = () => {
    return <svg enableBackground="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12 23.95c-3.19 0-6.19-1.24-8.45-3.5-2.26-2.26-3.5-5.26-3.5-8.45s1.24-6.19 3.5-8.45 5.26-3.5 8.45-3.5 6.19 1.24 8.45 3.5 3.5 5.26 3.5 8.45-1.24 6.19-3.5 8.45-5.26 3.5-8.45 3.5zm0-22.5c-2.82 0-5.47 1.1-7.46 3.09s-3.09 4.64-3.09 7.46 1.1 5.47 3.09 7.46c1.99 1.99 4.64 3.09 7.46 3.09s5.47-1.1 7.46-3.09 3.09-4.64 3.09-7.46-1.1-5.47-3.09-7.46-4.64-3.09-7.46-3.09z"/><path d="m11.3 6.56h1.4v7.98h-1.4z"/><path d="m11.3 15.99h1.4v1.45h-1.4z"/></svg>;
};

export default React.memo(Alert2);
